import { clientFetch } from '~/api/clientFetch';
import { ServiceUsage, serviceUsageSearchParams } from '../../types/model/serviceUsage';

export type ServiceUsageType = {
  service_usages: ServiceUsage[];
};

const endpoint = '/service_usages';

export async function fetchServiceUsage(
  signOut: () => void,
  searchParams?: serviceUsageSearchParams
): Promise<{ data: ServiceUsageType; headers: Record<string, string> }> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await clientFetch(
    endpoint,
    {
      method: 'GET',
      queryString,
    },
    signOut
  );
  const data = await response.json();
  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
}

export async function fetchServiceUsageCSV(signOut: () => void): Promise<{ data: Blob }> {
  const response = await clientFetch(
    `${endpoint}.csv`,
    {
      method: 'GET',
    },
    signOut
  );
  const data = await response.blob();

  return { data };
}
